module.exports = __webpack_public_path__ + "static/testing-0508d5d8c3b0c53a90cd3b51f580f20f.png";